var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconeOutros(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 15.15789794921875,
    width: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#36D896",
    fillOpacity: 1,
    opacity: 1,
    fillRule: "evenodd",
    d: "M15.15789794921875 3.60418701171875L15.15789794921875 1.6842041015625C15.155120849609375 0.75518798828125 14.4027099609375 0.00274658203125 13.47369384765625 0L1.6842041015625 0C0.754058837890625 0 0 0.7540283203125 0 1.6842041015625L0 13.47369384765625C0 14.40386962890625 0.754058837890625 15.15789794921875 1.6842041015625 15.15789794921875L13.47369384765625 15.15789794921875C14.4027099609375 15.15509033203125 15.155120849609375 14.4027099609375 15.15789794921875 13.47369384765625L15.15789794921875 11.5537109375C15.675872802734375 11.254638671875 15.99639892578125 10.703369140625 16 10.10528564453125L16 5.0526123046875C15.99639892578125 4.45452880859375 15.675872802734375 3.90325927734375 15.15789794921875 3.60418701171875ZM1.6842041015625 1.6842041015625L1.6842041015625 13.47369384765625L13.473663330078125 13.47369384765625L13.473663330078125 11.78948974609375L8.421051025390625 11.78948974609375C7.492034912109375 11.78668212890625 6.7396240234375 11.03424072265625 6.736846923828125 10.10528564453125L6.736846923828125 5.0526123046875C6.7396240234375 4.12359619140625 7.492034912109375 3.3712158203125 8.421051025390625 3.368408203125L13.473663330078125 3.368408203125L13.473663330078125 1.6842041015625L1.6842041015625 1.6842041015625ZM14.3157958984375 5.0526123046875L14.3157958984375 10.105224609375L8.421051025390625 10.105224609375L8.421051025390625 5.0526123046875L14.3157958984375 5.0526123046875Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#36D896",
    fillOpacity: 1,
    opacity: 1,
    rx: 1.2631578947368425,
    ry: 1.263157894736842,
    cx: 10.947368421052623,
    cy: 7.578947368421005
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeOutros);
export default __webpack_public_path__ + "static/media/icone-outros.205c67e1c9714ebf2a04118bd1dbee09.svg";
export { ForwardRef as ReactComponent };